<template>
  <div slot="header" class="payments-editor-header">
    <icon size="16" type="md-document" class="ms-help" />
    <span style="margin-left: 4px" class="ms-help">
      {{ getTitle() }}
    </span>
  </div>
</template>

<script>
import { parseDate } from '@/utils'

export default {
  props: ['payment'],
  methods: {
    getTitle () {
      const date =
        typeof this.payment.date === 'string'
          ? this.payment.date
          : parseDate(this.payment.date)
      const value = this.payment.id ? `Платеж от  ${date}` : 'Создание платежа'

      return value
    },
    parseDate
  }
}
</script>

<style lang="less">
.payments-editor-header {
  display: flex;
  align-items: center;
}
</style>
